import { Component, ComponentRef, Injector, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { LanguageModel, LanguageService } from '../../../../services/language.service';

import { UsersDialogComponent } from "../users-dialog/users-dialog.component";
import { DialogService } from "../../../../services/dialog.service";
import { AccessRights, UsersService, InterfacePermissions } from "../../../../services/users.service";
import { Router } from '@angular/router';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.css'],
    standalone: false
})
export class NavigationComponent implements OnInit {
  public InterfacePermissions = InterfacePermissions;
  private languageService: LanguageService;

  language: any;
  public languages: LanguageModel[];
  public usersService: UsersService;
  private dialogService: DialogService;
  private router: Router;

  constructor(private injector: Injector) {
    this.router = this.injector.get(Router);
    this.dialogService = this.injector.get(DialogService);
    this.usersService = this.injector.get(UsersService);
    this.languageService = this.injector.get(LanguageService);
    this.language = this.languageService.defaultLanguage;

    this.languageService.getLanguages().subscribe(langs => {
      this.languages = langs;
    });
  }

  changeLanguage(lang: string) {
    this.languageService.changeLanguage(lang);
    this.language = this.languageService.getLanguage();
  }

  logout() {
    this.usersService.logout();
  }

  ngOnInit(): void {
    this.languageService.getLanguages().subscribe(langs => {
      this.language = langs.find(l => l.code === this.languageService.getCulture())
        || this.languageService.defaultLanguage;
    });


    const user = this.usersService.getCurrentUser();
    if (user != null && this.router.url.length < 2) {
      if (user.HasFlag("START_ANALYTICS")) {
        this.router.navigate(["dashboard"]);
        return;
      }
      if (user.HasFlag("START_REPORTS")) {
        this.router.navigate(["reports"]);
        return;
      }
      if (user.HasFlag("START_DRIVERS")) {
        this.router.navigate(["drivers"]);
        return;
      }
      if (user.HasFlag("START_FUEL")) {
        this.router.navigate(["fuel"]);
        return;
      }
      if (user.HasFlag("START_SERVICE")) {
        this.router.navigate(["service"]);
        return;
      }
      if (user.HasFlag("START_DISPATCHER")) {
        this.router.navigate(["dispatcher"]);
        return;
      }


      if (user.IsActivity && user.TillLimitDate < Date.now()) {
        this.router.navigate(["history"]);
        return;
      }
    }

  }

  @ViewChild("navUsersDialog", { read: ViewContainerRef, static: true }) container;
  componentRef: ComponentRef<any>;

  public openUsersDialog() {
    /*this.container.clear();
    const factory: ComponentFactory<any> = this.resolver.resolveComponentFactory(UsersDialogComponent);

    this.componentRef = this.container.createComponent(factory);*/
    this.componentRef = this.dialogService.open(this.container, UsersDialogComponent);
    // this.usersService.openUsersDialogModal();

    /*this.componentRef.instance.onClose.subscribe(() => {
      console.log('destroying....');
      this.componentRef.destroy()
    });
    this.componentRef.instance.onSubmit.subscribe(() => {
      console.log('destroying....');
      this.componentRef.destroy()
    });*/
    // this.componentRef.instance.open();
  }

  protected readonly AccessRights = AccessRights;
}
